import angular from 'angular';
import moment from 'moment';

import templateUrl from './rogers-leaderboard-table.component.html';

export const RogersLeaderboardTableComponent = {
    controller: RogersLeaderboardTableController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        orders: "<",
        reportType: "<"
    }
}

function RogersLeaderboardTableController() {
    const vm = this;
    vm.today = moment().startOf("day");
    vm.$onInit = onInit;
    vm.sortByList = [{ name: "Top" }, { name: "Bottom" }];
    vm.sortBy = vm.sortByList[0];
    vm.sortCount = 50;
    vm.sortOrder = sortOrder;
    vm.$onChanges = onChanges

    function onInit() {
        vm.filteredBookedOrders = angular.copy(vm.orders.BookedLeaderBoard);
        vm.filteredConfirmedOrders = angular.copy(vm.orders.ConfirmedLeaderBoard);
        sortOrder()
    }

    function sortOrder() {

        sortAndTakeBookedOrders();
        sortAndTakeConfirmedOrders();
    }

    function onChanges() {
        if (vm.orders && vm.orders.BookedLeaderBoard) {
            sortOrder();
        }
        if (vm.orders && vm.orders.ConfirmedLeaderBoard) {
            sortOrder();
        }
    }

    function sortAndTakeBookedOrders() {
        if (vm.sortBy.name === "Top") {
            vm.filteredBookedOrders = vm.orders.BookedLeaderBoard.sort(function (a, b) {
                return b.Total - a.Total
            })
        } else {
            vm.filteredBookedOrders = vm.orders.BookedLeaderBoard.sort(function (a, b) {
                return a.Total - b.Total
            })
        }
        vm.filteredBookedOrders = vm.filteredBookedOrders.length > 0
            ? vm.filteredBookedOrders.slice(0, vm.sortCount) : [];
    }


    function sortAndTakeConfirmedOrders() {
        if (vm.sortBy.name === "Top") {
            vm.filteredConfirmedOrders = vm.orders.ConfirmedLeaderBoard.sort(function (a, b) {
                return b.Total - a.Total
            })
        } else {
            vm.filteredConfirmedOrders = vm.orders.ConfirmedLeaderBoard.sort(function (a, b) {
                return a.Total - b.Total
            })
        }
        vm.filteredConfirmedOrders = vm.filteredConfirmedOrders.length > 0
            ? vm.filteredConfirmedOrders.slice(0, vm.sortCount) : [];
    }

}
